import { render } from "./ChatEntry.vue?vue&type=template&id=bb94a28c"
import script from "./ChatEntry.vue?vue&type=script&lang=js"
export * from "./ChatEntry.vue?vue&type=script&lang=js"

import "./ChatEntry.vue?vue&type=style&index=0&id=bb94a28c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__